import { Component } from '@angular/core'
import { ImageViewerService } from './image-viewer.service'

@Component({
  selector: 'chat-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent {

    image$ = this.imageViewerService.image$

    constructor(
        private imageViewerService: ImageViewerService
    ) {}

    close(): void {
        this.imageViewerService.close()
    }

    getFileName(name?: string, url?: string): string {
        if (name) {
            return name.split('/').pop() || name;
        }

        if (url) {
            try {
                return decodeURIComponent(url.split('?')[0].split('/').pop() || '') || 'imagem';
            } catch {
                return 'imagem';
            }
        }

        return 'imagem';
    }

    download(image: { url: string; name: string; type?: string }): void {
        fetch(image.url, { cache: 'no-cache' })
            .then(resposta => {
                if (!resposta.ok) {
                    throw new Error(`Falha ao baixar arquivo: ${resposta.status}`);
                }
                return resposta.blob();
            })
            .then(blob => {
                const urlBlob = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = urlBlob;
                a.download = this.getFileName(image.name, image.url);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(urlBlob);
            })
            .catch(() => window.open(image.url, '_blank', 'noopener'));
    }
}
